import { useEffect } from "react";

import DropOffPlannerView from "../../components/dropOffPlanner/DropOffPlannerView";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DropOff() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Drop Off Leads",
      desc: "Book drop off leads across the coming days",
    });
  }, [setInfo]);

  return <DropOffPlannerView />;
}
